import type { SmartGuideLocationProfile } from "../BrowserLocation/SmartGuideLocationBroker";

const minimumPreciseEntryDistanceMeters = 250;
const accuracyEntryMarginMeters = 250;
const minimumBalancedReturnDistanceMeters = 500;
const accuracyExitMarginMeters = 500;
const balancedReturnDurationMs = 30_000;

export class GpsTriggerPrecisionPolicy {
    private currentProfile: SmartGuideLocationProfile = "balanced";
    private farSinceTimestamp?: number;

    update(distanceMeters: number, accuracyMeters: number, positionTimestamp: number): SmartGuideLocationProfile {
        const entryThreshold = Math.max(minimumPreciseEntryDistanceMeters, accuracyMeters + accuracyEntryMarginMeters);
        if (this.currentProfile === "balanced") {
            if (distanceMeters <= entryThreshold) {
                this.currentProfile = "precise";
            }
            return this.currentProfile;
        }

        const exitThreshold = Math.max(minimumBalancedReturnDistanceMeters, accuracyMeters + accuracyExitMarginMeters);
        if (distanceMeters <= exitThreshold) {
            this.farSinceTimestamp = undefined;
            return this.currentProfile;
        }

        if (this.farSinceTimestamp === undefined || positionTimestamp < this.farSinceTimestamp) {
            this.farSinceTimestamp = positionTimestamp;
            return this.currentProfile;
        }

        if (positionTimestamp - this.farSinceTimestamp >= balancedReturnDurationMs) {
            this.currentProfile = "balanced";
            this.farSinceTimestamp = undefined;
        }

        return this.currentProfile;
    }
}
